


<div #myModal2 class="modal fade" id="modal-sm">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">¿Está seguro de Anular?</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <!-- <div class="modal-body">
        <p>One fine body&hellip;</p>
      </div> -->
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-primary" data-dismiss="modal">No</button>
        <button type="button" class="btn btn-primary" (click)="OnAnulaProducto()">Si</button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>



<div #myModal class="modal fade" id="modal-lg">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Búsqueda de productos.</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>



      <div class="modal-body">


        <div class="card-tools">
         
         

            <div class="input-group-append">
              <input type="text" [(ngModel)]='txtBuscar' name="table_search" class="form-control float-right" placeholder="Escriba un modelo" autocomplete="off">
              <button type="button" class="btn btn-default" (click)="OnBuscarPorModelo()">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        <table class="table table-bordered">
          <thead>
            <tr  >
              <th style="width: auto">Modelo </th>
              <th style="width:auto">Descripción</th>
              <th style="width: auto">Categoria</th>
              <th style="width: auto">Precio</th>
            <th style="width: 300px"></th>
            <th style="width: auto"></th>
            </tr>
          </thead>
          <tbody>
            <tr  *ngFor="let dato of productodto; let i=index">
              <td >{{dato.modelo}}</td>
              <td>{{dato.descripcion}}</td>
              <td> {{dato.categoria}}</td>
              <td>Q.{{dato.precio}}</td>
              <td style="text-align: center;"><img  src={{urlServerUpload$}}{{dato.imagen}}{{tipoMedia$}} style="width: 40%;height: 40%;"></td>
              <td >  <a class="btn btn-app" (click)="OnSeleccionarProducto(dato.idProducto)">
                <i class="fas fa-edit"></i> {{tituloBotonSelect}}
              </a></td>
            </tr>
            
            
          </tbody>
        </table>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
       
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="card-body">
          <a class="btn btn-app bg-secondary" (click)="OnAbrirBusqueda()">
         
            <i class="fas fa-barcode" ></i> Buscar
          </a>
          </div>
        <!-- left column -->
        <div class="col-md-8">
         
<div class="card card-primary">
    <div class="card-header">
      <h3 class="card-title">Datos del Producto</h3>
    </div>
    <!-- /.card-header -->
    <!-- form start -->
    <form  [formGroup]="formProducto"   >
      <div class="card-body">

        <div class="form-group">
          <label for="labelImagen1">1er. imagen</label>
          <div class="input-group">
            <div class="custom-file">
              <input type="file" class="custom-file-input" accept=".jpg,.png" id="inputFile" (change)="onFileSelected($event)" #fileUpload>
              <label class="custom-file-label" for="lblarchivo">{{this.nombreArchivo}}</label>
            </div>
            
          </div>

          <div *ngIf="errorForm[0] == '1'">
            <label for="label1"><code>Debe Seleccionar seleccionar alguna imagen.</code></label>
          </div>

          <div *ngIf="previsualizacion">
            <img width="100px" [src]="previsualizacion" alt="50px">
        </div>
        </div>


        <div class="form-group">
          <label for="labelImagen2">2da. imagen</label>
          <div class="input-group">
            <div class="custom-file">
              <input type="file" class="custom-file-input" accept=".jpg,.png" id="inputFile2" (change)="onFileSelected2($event)" #fileUpload2>
              <label class="custom-file-label" for="lblarchivo2">{{this.nombreArchivo2}}</label>
            </div>
            
          </div>
          <div *ngIf="errorForm[1] == '1'">
            <label for="label1"><code>Debe Seleccionar seleccionar alguna imagen.</code></label>
          </div>
          <div *ngIf="previsualizacion2">
            <img width="100px" [src]="previsualizacion2" alt="50px">
        </div>
        </div>

        <div class="form-group">
          <label for="labelImagen3">3er. imagen</label>
          <div class="input-group">
            <div class="custom-file">
              <input type="file" class="custom-file-input" accept=".jpg,.png" id="inputFile3" (change)="onFileSelected3($event)" #fileUpload3>
              <label class="custom-file-label" for="lblarchivo3">{{this.nombreArchivo3}}</label>
            </div>
            
          </div>
          <div *ngIf="errorForm[2] == '1'">
            <label for="label1"><code>Debe Seleccionar seleccionar alguna imagen.</code></label>
          </div>
          <div *ngIf="previsualizacion3">
            <img width="100px" [src]="previsualizacion3" alt="50px">
        </div>
        </div>
       

       

        <div class="form-group">
          <label for="label1">Modelo</label>
          <input type="text" class="form-control"  placeholder="Describa el producto" maxlength="20" formControlName="txtModelo">
        </div>

        <div *ngIf="errorForm[3] == '1'">
          <label for="label1"><code>No puede quedar vacío.</code></label>
        </div>


        <div class="form-group">
          <label for="label1">Descripción</label> 
          <input type="text" class="form-control"  placeholder="Escriba una descripción" maxlength="30" formControlName="txtDescripcion" >
        </div>

        <div *ngIf="errorForm[4] == '1'">
          <label for="label1"><code>No puede quedar vacío.</code></label>
        </div>

        <div class="form-group">
          <label for="label1">Detalles</label>
          <textarea class="form-control"  placeholder="Escriba algun detalle"  formControlName="txtDetalles"></textarea>
        
         
        </div>
        <div *ngIf="errorForm[5] == '1'">
          <label for="label1"><code>No puede quedar vacío.</code></label>
        </div>

        <div class="form-group">
         
            <!-- select -->
            <div class="form-group">
              <label>Categoria</label>
              <select class="form-control" formControlName="cmbCategoria">
                
                <option *ngFor="let dato of categoria; let i=index" value={{dato.idCategoria}}>{{dato.descripcion}}</option>
              </select>
            </div>
            <div *ngIf="errorForm[6] == '1'">
              <label for="label1"><code>Seleccione algo.</code></label>
            </div>
        </div>

        <div class="form-group">
         
          <!-- select -->
         
            <label>Marca</label>
            <select class="form-control" formControlName="cmbMarca">
              
              <option *ngFor="let dato of marca; let i=index" value={{dato.idMarca}}>{{dato.descripcion}}</option>
            </select>
        
            <div *ngIf="errorForm[7] == '1'">
              <label for="label1"><code>Seleccione algo.</code></label>
            </div>
      </div>


      <div class="form-group">
        <label for="label1">Precio Público</label>
        <input type="number" class="form-control"  placeholder="0.00"  formControlName="txtPrecio">
      </div>

      <div *ngIf="errorForm[8] == '1'">
        <label for="label1"><code>Número incorrecto.</code></label>
      </div>

      <div class="form-group">
        <label for="label1">Descuento (%)</label>
        <input type="number" class="form-control"  placeholder="0.00"  formControlName="txtPrecio2">

        <div *ngIf="errorForm[9] == '1'">
          <label for="label1"><code>Número incorrecto.</code></label>
        </div>
      </div>


      <div class="form-group">
        <label for="label1">Otros Detalles</label>
        <input type="text" class="form-control"  placeholder="Altura" maxlength="50" formControlName="txtAltura">
        <div *ngIf="errorForm[10] == '1'">
          <label for="label1"><code>Este campo no puede quedar vacío.</code></label>
        </div>
      </div>

      <div class="form-group">
        <label> Estado</label>
        <select class="form-control" formControlName="cmbEstado"   >
          <option value="1"> HABILITADO</option>
          <option value="2"> DESHABILITADO</option>
        </select>
       
      </div>
      <div *ngIf="errorForm[11] == '1'">
        <label for="label1"><code>Debe Seleccionar algún estado.</code></label>
      </div>

      <div class="form-group">
        <label> Limitar Existencia</label>
        <select class="form-control" formControlName="cmbLimitarExistencia"   >
          <option value="NO"> NO</option>
          <option value="SI"> SI</option>
        </select>
       
      </div>


       
      </div>
      <!-- /.card-body -->

      
      
     

    </form>
  </div>



  <div class="card card-primary">
    <div class="card-header">
      <h3 class="card-title">Colores y Tallas</h3>
    </div>
    <!-- /.card-header -->
    <!-- form start -->
    <form   [formGroup]="formProducto2"   >
      <div class="card-body">



     
          <!-- select -->
          <div class="form-group">
            <label>Color</label>
            <select class="form-control" formControlName="cmbColor" style="font-size: 20px;" (change)="OnSelectColor()">
              <option *ngFor="let dato of color; let i=index" [style.background]=dato.valorColor value={{dato.idColor}}> {{dato.valorColor}}</option>
            </select>
            <div class="small-box bg-info" >
              <div class="inner" [style.background]=valorColorSeleccionado>
               <br>
              </div>
            </div>
            <div *ngIf="errorForm2[0] == '1'">
              <label for="label1"><code>Debe Seleccionar un Color</code></label>
            </div>
        

          </div>
      
          


          <div class="form-group">
            <label>Tipo Talla</label>
            <select class="form-control" formControlName="cmbTipoTalla"  (change)="OnTallaByTipoTalla()" >
              <option *ngFor="let dato of tipotalla; let i=index" value={{dato.idTipoTalla}}>{{dato.descripcion}}</option>
            </select>
            <div *ngIf="errorForm2[1] == '1'">
              <label for="label1"><code>Debe Seleccionar Tipo de talla</code></label>
            </div>
          </div>

          <div class="form-group">
            <label>Talla</label>
            <select class="form-control" formControlName="cmbTalla"  (change)="OnSelectTalla()" >
              <option *ngFor="let dato of talla; let i=index" value={{dato.idTalla}}>{{dato.descripcion}}</option>
            </select>
            <div *ngIf="errorForm2[2] == '1'">
              <label for="label1"><code>Debe Seleccionar una Talla</code></label>
            </div>
          </div>

          <div class="form-group" style="text-align:center">
            <div class="card-footer" >
              <button type="button" class="btn btn-warning" (click)="OnAgregarColorTalla()">Agregar</button>
            </div>
          </div>

       
        <table class="table table-bordered">
          <thead>
            <tr >
              <th style="width: 60px"> Color</th>
              <th style="width: 60px">Talla</th>
              <th style="width: 30px">Acción</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let dato of colortalladto; let i=index">
              <td [style.background]=dato.codigoColor></td>
              <td>{{dato.talla}}</td>
              <td ><img src="./assets/dist/img/delete.png"  (click)="OnEliminarLista(dato.indice)"> </td>
            </tr>
            
            
          </tbody>
        </table>

        
       

      </div>


 
      <div class="form-check">
         
      </div>

    <!-- /.card-body -->

   



 


    </form>
  </div>


    
  <div class="card card-primary">
    <div class="card-header">
      <h3 class="card-title">Productos Relacionados</h3>
    </div>
    <!-- /.card-header -->
    <!-- form start -->
    <form   [formGroup]="formProducto2"   >
      <div class="card-body">

        <div class="form-group">
          <div class="input-group-append">
            <a class="btn btn-app bg-secondary" (click)="OnAbrirBusqueda2()">
         
              <i class="fas fa-barcode" ></i> Buscar
            </a>
            </div>
        </div>


        <table class="table table-bordered">
          <thead>
            <tr >
              <th style="width: 60px"> Modelo</th>
              <th style="width: 60px">Foto</th>
              <th style="width: 30px">Acción</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let dato of productoRel; let j=index" >
              <td >{{dato.modelo}}</td>
              <td style="text-align: center;"><img  src={{urlServerUpload$}}{{dato.imagen}}{{tipoMedia$}} style="width: 40%;height: 40%;"></td>
              <td ><img src="./assets/dist/img/delete.png" (click)="OnEliminarLista2(dato.indice)"> </td>
            </tr>
            
            
          </tbody>
        </table>





      </div>
      



      <div class="card-footer" style="text-align: center;">
        <div *ngIf="esperar == true" class="overlay"><i class="fas fa-3x fa-sync-alt fa-spin"></i><div class="text-bold pt-2">Espere...</div></div>
        <button type="button" class="btn btn-primary" (click)="OnGuardarProducto()">{{this.tituloBotonGuardar}}</button>
        <button type="button"  class="btn btn-danger"  formControlName="btnEliminar" *ngIf="mostrarButtonEliminar == true"  (click)="OnAbrirConfirmacion()" >Eliminar</button>
       
      </div>
    </form> 
  </div>



</div>
</div>
</div>
</section>
